import currencyFormatter from 'currency-formatter';
import getSymbolFromCurrency from 'currency-symbol-map';

// currency-formatter is mainly used for currency placement (R/L) and separators
// currency-symbol-map is used for retrieving the right currency symbol
// improvement to do: combine libraries
export const formatMoney = (value, currency) =>
  currencyFormatter.format(value, {
    code: currency,
    symbol: getSymbolFromCurrency(currency),
    precision: Number.isInteger(value) ? 0 : 2,
  });
